import ApolloClient from 'apollo-client'
import createDecorator from 'final-form-calculate'
import { TipoAtendimentoProfissional } from 'graphql/types.generated'

import { createDesfechoCalculations } from '../detail/soap/desfecho/calculator'
import { createObjetivoCalculations } from '../detail/soap/objetivo/calculator'
import { createPlanoCalculations } from '../detail/soap/plano/calculator'
import { ProcedimentosAutomaticos } from './AtendimentoIndividualView'
import { meta } from './model'

export const createAtendimentoIndividualCalculator = (
  apollo: ApolloClient<object>,
  procedimentosAutomaticos: ProcedimentosAutomaticos,
  isMedico: boolean,
  tipoAtendProf: TipoAtendimentoProfissional,
  isCEO?: boolean
) =>
  createDecorator(
    ...createObjetivoCalculations(meta.objetivo),
    ...createPlanoCalculations(meta.plano, meta.objetivo.medicoes, procedimentosAutomaticos),
    ...createDesfechoCalculations(
      meta.desfecho.desfechoAtendimento.atendimento,
      apollo,
      isMedico,
      procedimentosAutomaticos,
      tipoAtendProf,
      isCEO
    )
  )
